import { createContext } from 'react';

export const TranslationContext = createContext();
